__webpack_require__.p = "/wp-content/themes/bioagilytix-2023/js/";